import * as ApiManager from './_manager';
import store from '@/store';

export const customer = {
  delete: payload => {
    return ApiManager.callApi (
      `/member/company/customer/${payload.customer_id}/delete`,
      payload
    );
  },

  getCustomerList: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/customer/list`,
      payload
    );
  },

  deleteAll: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/customer/delete`,
      payload
    );
  },

  showPassword: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/customer/show_password`,
      payload
    );
  },

  sendVerificationsEmails: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/customer/send_verification_emails`,
      payload
    );
  },

  sendReminders: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/customer/send_reminders`,
      payload
    );
  },

  download: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/customer/download`,
      payload
    );
  },
};
